<template>
    <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9551 0.939453L18.3693 2.35367L9.66218 11.0608L0.955078 2.35367L2.36929 0.939453L9.66218 8.23235L16.9551 0.939453Z" 
        :fill="color || '#10233E'"/>
    </svg>
        
</template>

<script>
export default {
    props: ['color']
};
</script>